import {h, Fragment} from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import {Form, Container, Row, Col, I18n} from 'components/elements'
import {AppointmentFilters, WaitingRoom, OperatingHours} from 'components/groups'
import {Login,PasswordReset,ResetPasswordPrompt,PatientSelect} from 'components/partials';
import style from './index.less'
import {AccountActions, SessionActions} from 'actions'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import dayjs from 'dayjs'
import { OrganizationActions } from 'actions';

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

@Form
@connect((state)=> state)
class Sessions extends WidgetComponent {
    constructor(props){
        super(props)
        this.state = {
            authenticator: '',
            authenticatorExists: false,
            processing: false,
            sendReset: false
        }
        
        this.navToTimeSlots = this.navToTimeSlots.bind(this)
        this.handleLogOut = this.handleLogOut.bind(this)
        this.handleAuthenticatorChange = this.handleAuthenticatorChange.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
        this.handlePasswordResetPrompt = this.handlePasswordResetPrompt.bind(this)
    }

    componentWillMount(){
		super.componentWillMount()
        if(this.account.email || this.account.mobilePhone){
            if(!this.session.accountID){
                this.handleAuthenticatorChange(this.account.email || this.account.mobilePhone)
            } else {
                this.setState({
                    authenticator: this.account.email || this.account.mobilePhone
                })
            }
		}
    }
    
    get login(){
        return (
            this.props.sessions || {}
        ).type === 'login'
    }

    get config(){
        return this.props.config || {}
    }

    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get session(){
        return this.props.session || {}
    }

    get account(){
        return this.session.account || {}
    }

    get patients(){
        return Object.values(this.props.patients || {})
    }

    get isButtonDisabled(){
        if((this.session.accountID || this.account.email || this.account.mobilePhone || (this.state.authenticator && !this.state.authenticatorExists))){
            if(this.props.config.placeholderAppointment){
                return (!this.session.accountID && this.state.authenticatorExists) || (this.session.accountID && Object.keys(this.props.selectedPatients).length != this.props.filters.patientCount)
            } else {
                return !this.session.accountID && this.state.authenticatorExists
            }
        }
        return true
    }

    get openTimes(){
        return window.NILRepeating && NILRepeating.all({
            data: Object.values(this.props.openTimes || {}), 
            startingAt: dayjs().startOf('week').format(), 
            endingAt: dayjs().endOf('week').format(), 
            recast: dayjs,
            getPastItems: true
        }) || []
    }

    get waitingRoomAdmin(){
        for(let admin of Object.values(this.props.administrators)){
            if(admin.isWaitingRoom){
                return admin
            }
        }
    }

    get waitingRoomHours(){
        let waitingRoomAdmin = this.waitingRoomAdmin
        if(waitingRoomAdmin){
            let waitingRoomShifts = this.props.shifts[waitingRoomAdmin.id]
            return window.NILRepeating && NILRepeating.all({
                data: Object.values(waitingRoomShifts || {}), 
                startingAt: dayjs().startOf('week').format(), 
                endingAt: dayjs().endOf('week').format(), 
                recast: dayjs,
                getPastItems: true
            }) || []
        }
        return []
    }

    get isWaitingRoomOpen(){
        let now = dayjs()

        let waitingRoomAdmin = this.waitingRoomAdmin
        let waitingRoomShifts = []
        if(waitingRoomAdmin){
            waitingRoomShifts = window.NILRepeating && NILRepeating.all({
                data: Object.values(this.props.shifts[waitingRoomAdmin.id] || {}), 
                startingAt: dayjs().startOf('day').format(), 
                endingAt: dayjs().endOf('day').format(), 
                recast: dayjs,
                getPastItems: true
            }) || []
        }

        let waitingRoomOpen = false
        for(let shift of waitingRoomShifts){
            if(now.isSameOrBefore(shift.endsAt) && now.isSameOrAfter(shift.startsAt)){
                waitingRoomOpen = true
            }
        }

        if(waitingRoomOpen){
            for(let admin of Object.values(this.props.administrators)){
                if(!admin.isWaitingRoom){
                    let adminShifts = this.props.shifts[admin.id]
                    adminShifts = window.NILRepeating && NILRepeating.all({
                        data: Object.values(adminShifts || {}), 
                        startingAt: dayjs().startOf('day').format(), 
                        endingAt: dayjs().endOf('day').format(), 
                        recast: dayjs,
                        getPastItems: true
                    }) || []
                    for(let shift of adminShifts){
                        if(now.isSameOrBefore(shift.endsAt) && now.isSameOrAfter(shift.startsAt)){
                            return true
                        }
                    }
                }
            }
        }
        return false
    }

    fetchOrganizationData(){
        if(Object.keys(this.props.breeds).length == 0){
            OrganizationActions.findPatientDataByID(this.props.organization.id).then((res)=>{
                super.componentDidSubmit()
            })
        } else {
            super.componentDidSubmit()
        }
    }

    navToTimeSlots(submitData) {
        if(!this.isButtonDisabled && (this.session.accountID || this.account.email || this.account.mobilePhone || (this.state.authenticator && !this.state.authenticatorExists))){
            this.fetchOrganizationData()
        }
    }

    handlePasswordResetPrompt(){
        this.setState({
            sendReset: !this.state.sendReset
        })
    }

    handleLogOut(){
        SessionActions.logout()
    }

    handleAuthenticatorChange(e){
        if(e.target){
            let value = e.target.value
            this.setState({
                processing: true,
                Authenticator: value
            })
            AccountActions.fetch({authenticator: value}).then((response)=>{
                let stateData = {
                    authenticator: value,
                    processing: false
                }
                if(response.data){
                    stateData.authenticatorExists = true
                } else {
                    stateData.authenticatorExists = false
                }
                this.setState(stateData)
                
                if(!this.account.id){
                    let data = {}
                    
                    if(value.includes('@')){
                        data.email = value
                    } else {
                        data.mobilePhone = value
                    }
                    AccountActions.set(data)
                }
            })
            .catch((e)=>{
            })
        }
    }

    handlePatientSelect(){
        this.setState({})
    }

    render(){
        let spanValue
        if(this.props.config.placeholderAppointment){
            spanValue = !this.session.accountID ? 8 : 12
        } else {
            spanValue = !this.session.accountID ? 6 : 9
        }
        return (
            <div>
                {this.props.waitingRoom || this.props.loading.waitingRoom ? (
                    !this.props.waitingRoom || this.props.loading.organization || this.props.loading.appointments ? (
                        <div class={style.spinnerContainer}>
                            <i class={`fa fa-spinner fa-spin`} aria-hidden="true"></i>
                        </div>
                    ) : (
                        <WaitingRoom closed={!this.isWaitingRoomOpen} spinner={this.props.loading.waitingRoom}/>
                    )
                ) : (
                    ''
                )} 
                {this.props.config.showOperatingHours && 
                    <Row>
                        <Col span={{sm: 0, md: 1, lg: 3}}></Col>
                        <Col span={{sm: 24, md: 11, lg: 9}}>
                            <OperatingHours hours={this.openTimes} header='Clinic Hours' spinner={this.props.loading.openTimes || this.props.loading.organization}/>
                        </Col>
                        {(this.props.loading.waitingRoom || this.props.waitingRoom) && 
                            <Col span={{sm: 24, md: 11, lg: 9}}>
                                <OperatingHours forceClose={!this.isWaitingRoomOpen} hours={this.waitingRoomHours} header='Online Check-In' spinner={this.props.loading.waitingRoom || this.props.loading.organization}/>
                            </Col>
                        }
                        <Col span={{sm: 0, md: 1, lg: 3}}></Col>
                    </Row>
                }
                {this.props.waitingRoom && !this.props.loading.organization && !this.isWaitingRoomOpen?
                    <Container class={style.closedMessage}>
                        {_.get(this.props, "organization.settings.waitingRoomClosedMessage") || <Fragment>Online check-in is currently unavailable for this clinic. Please come back during the 'check-in' hours posted above, or walk in any time the clinic is open.</Fragment>}
                    </Container>
                : (
                    this.props.loading.organization ? (
                        <div style={{height: '240px', paddingTop: '70px'}}>
                            <i class={`fa fa-spinner fa-spin ${style.spinner}`} aria-hidden="true"></i>
                        </div>
                    ) : (
                        <AppointmentFilters
                            class={this.props.config.showOperatingHours ? style.businessHoursFilterPadding : style.filterPadding}
                            onSubmit={this.navToTimeSlots}
                            disabled={this.isButtonDisabled}
                            placeholderAppointment={this.props.config.placeholderAppointment}
                            authenticator={!this.session.accountID && {
                                    required: true,
                                    span: spanValue,
                                    onBlur: this.handleAuthenticatorChange,
                                    initialValue: this.state.authenticator || this.account.email || this.account.mobilePhone
                                }}
                            PatientCountFilters={{
                                    required: true,
                                    data: this.patientCount,
                                    initialValue: this.props.filters.patientCount,
                                    span: spanValue
                                }}
                            appointmentTypeFilters={{
                                    required: true,
                                    data: this.appointmentTypes,
                                    initialValue: this.props.filters.appointmentTypeID,
                                    span: spanValue
                                }}
                            dateFilters={!this.props.config.placeholderAppointment && {
                                    required: true,
                                    initialValue: this.props.filters.startDate,
                                    span: 6
                                }}
                        />
                    )
                )}
                {this.props.config.placeholderAppointment && this.session.accountID && this.props.filters.patientCount && 
                    <PatientSelect layout='horizontal' onPatientSelect={this.handlePatientSelect}/>
                }
                {!this.session.accountID && this.state.authenticatorExists &&
                    <div class={style.errorText}>
                        <I18n>thisEmailOrPhone</I18n> {this.props.organization.name} <I18n>ifThisIsYourFirst</I18n>
                        <br /><br /><br />
                    </div>
                }
                {Object.values(this.props.appointmentTypes || {}).length > 0 && this.appointmentTypes.length == 0 && !this.session.accountID && this.state.authenticator && !this.state.authenticatorExists &&
                    <div class={style.errorText}>
                        <I18n>noProvideNew</I18n>
                        <br /><br /><br />
                    </div>
                }
                {Object.values(this.props.appointmentTypes || {}).length > 0 && this.appointmentTypes.length == 0 && this.session.accountID &&
                    <div class={style.errorText}>
                        <I18n>noProvideExisting</I18n>
                        <br /><br /><br />
                    </div>
                }
                {this.session.accountID &&
                    <div>
                        <div class={style.loggedInTitle}>
                            <I18n>welcome</I18n>, {this.account.title} {this.account.firstName} {this.account.lastName}
                        </div>
                        {!this.session.resetPassword &&
                            <div class={style.logOutPrompt}>
                                <I18n>not</I18n> {this.account.firstName}? <div class={style.logOutLink} onClick={this.handleLogOut}><I18n>clickHereToLogOut</I18n></div>
                            </div>
                        }
                    </div>
                }
                {!this.session.authenticating &&
                    <div class={style.loginSignup}>
                        {this.session.resetPassword ?
                            <PasswordReset />
                        :
                            (this.state.sendReset ?
                                <ResetPasswordPrompt handlePasswordResetPrompt={this.handlePasswordResetPrompt}/>
                            :
                                (!this.session.accountID &&
                                    <Login 
                                        authenticator={this.state.authenticatorExists ? this.state.authenticator : ''}
                                        handlePasswordResetPrompt={this.handlePasswordResetPrompt}
                                    />
                                )
                            )
                        }
                    </div>
                }
            </div>
        )
    }
}
export default Sessions


// WEBPACK FOOTER //
// ./components/templates/Sessions/index.js